// import { IConfigSeller } from '@/models/configSeller'
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { TiDocumentAdd } from 'react-icons/ti'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IAppStore } from '../../../../models/store.model'
import { webApiService } from '../../../../services'
import { useTradeinContext } from '../hooks/useTradeinContext'

const AddPurchaseDevice = () => {
  const [data, setData] = useState<{ open: boolean, loading: boolean, device_purchased: string, listCR: any[] }>({ open: false, loading: false, device_purchased: '', listCR: [] })
  const { id, slug } = useParams()
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  // const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)

  const handleClose = () => {
    setData({ ...data, open: false, loading: false, device_purchased: '' })
  }

  const handleSave = () => {
    setData({ ...data, loading: true })
    webApiService.updatePurchaseTradein({ id_tradein: Number(id), id_user: userState.id, device_purchased: data.device_purchased, seller: slug }).then(() => {
      enqueueSnackbar('Dispositivo agregado correctamente', { variant: 'success' })
      setData({ ...data, loading: false, device_purchased: '', open: false })
      saveCtx({ ...ctx, reload: true })
    }).catch((error: any) => {
      enqueueSnackbar('Hubo un error al agregar el dispositivo', { variant: 'error' })
      setData({ ...data, loading: false })
      console.log('error ==>', error)
    })
  }

  return (
    <div>
      <Button
        variant='shadow'
        color='success'
        size='sm'
        className='ml-2'
        endContent={<TiDocumentAdd style={{ fontSize: '12px' }} />}
        onClick={() => { setData({ ...data, open: true }) }}
      >
        Agregar Dispositivo de Compra
      </Button>

      <Modal backdrop='blur' isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>Agregar Dispositivo de Compra</ModalHeader>
          <ModalBody>
            <h4 className='text-lg mb-2 font-black'>Ingrese el nombre del dispositivo comprado asociado al Trade-In </h4>
            <Input
              label='Ingrese el nombre del dispositivo'
              value={data.device_purchased}
              fullWidth
              onValueChange={(value) => { setData({ ...data, device_purchased: value }) }}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              color='danger'
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button color='primary' type='submit' isDisabled={data.device_purchased === '' || data.loading} onClick={handleSave}>
              {data.loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default AddPurchaseDevice
